import { motion, useInView } from "framer-motion";
import { useRef } from "react";
import { Target, Shield, Users, BarChart3, MousePointerClick, Zap, MessageCircle } from "lucide-react";

const SolutionSection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  const benefits = [
    { icon: Target, title: "Captação de leads", desc: "Formulários otimizados para converter visitantes em contatos qualificados." },
    { icon: Shield, title: "Credibilidade profissional", desc: "Um site profissional que aumenta a confiança de quem visita." },
    { icon: Users, title: "Organização de contatos", desc: "Todos os leads em um só lugar, prontos para follow-up." },
    { icon: BarChart3, title: "Performance de anúncios", desc: "Páginas otimizadas para maior retorno do investimento em tráfego." },
  ];

  const flow = [
    { icon: MousePointerClick, label: "Anúncio", color: "bg-primary/20 text-primary" },
    { icon: Zap, label: "Landing Page", color: "bg-secondary/20 text-secondary" },
    { icon: Users, label: "Lead", color: "bg-primary/20 text-primary" },
    { icon: MessageCircle, label: "WhatsApp", color: "bg-green-500/20 text-green-400" },
  ];

  return (
    <section id="solucao" className="py-24 md:py-32 relative" ref={ref}>
      <div className="container mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <span className="text-sm font-mono text-secondary uppercase tracking-widest">A solução</span>
          <h2 className="text-3xl md:text-5xl font-bold mt-4">
            Transforme visitantes em <span className="gradient-text">clientes.</span>
          </h2>
        </motion.div>

        {/* Flow */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ delay: 0.3 }}
          className="flex flex-wrap items-center justify-center gap-3 md:gap-4 mb-20"
        >
          {flow.map((item, i) => (
            <div key={i} className="flex items-center gap-3 md:gap-4">
              <div className={`rounded-2xl p-4 md:p-5 ${item.color} flex items-center gap-3`}>
                <item.icon className="w-6 h-6" />
                <span className="font-semibold text-sm">{item.label}</span>
              </div>
              {i < flow.length - 1 && <span className="text-xl text-muted-foreground">→</span>}
            </div>
          ))}
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {benefits.map((b, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 20 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ delay: 0.4 + i * 0.1 }}
              className="glass-card rounded-2xl p-6 hover:border-primary/30 transition-colors group"
            >
              <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center mb-4 group-hover:bg-primary/20 transition-colors">
                <b.icon className="w-6 h-6 text-primary" />
              </div>
              <h3 className="font-semibold mb-2">{b.title}</h3>
              <p className="text-sm text-muted-foreground">{b.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SolutionSection;
